import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { TokenService } from '@kitch/data-access/services';

interface FavoritesMenu {
  id: number;
  link?: string;
  name: string;
}

@Component({
  selector: 'app-my-favorites',
  templateUrl: './my-favorites.component.html',
  styleUrls: ['./my-favorites.component.scss'],
})
export class MyFavoritesComponent implements OnInit {
  menu: FavoritesMenu[];
  activeRoute: number;
  myProfileId: string;

  constructor(
    private router: Router,
    private tokenService: TokenService,
    private $gaService: GoogleAnalyticsService,
  ) { }

  ngOnInit(): void {
    this.myProfileId = this.tokenService.getProfileId();
    this.menu = [
      {
        id: 0,
        name: 'Upcoming',
        link: '/my-stuff/upcoming/',
      },
      {
        id: 1,
        name: 'Channels',
        link: '/my-stuff/channels/',
      },
      {
        id: 2,
        name: 'Streams',
        link: '/my-stuff/streams/',
      },
      {
        id: 3,
        name: 'Recipes',
        link: '/my-stuff/recipes/',
      },
      {
        id: 4,
        name: 'Courses',
        link: '/my-stuff/clubs/',
      },
      {
        id: 5,
        name: 'Products',
        link: '/my-stuff/products/',
      },
    ];

    for (let i = 0; i < this.menu.length; i++) {
      if (this.menu[i].link === `${this.router.url}/`) {
        this.activeRoute = i;
        break;
      }
      if (i === this.menu.length) {
        this.activeRoute = 3;
      }
    }

    this.$gaService.pageView(
      '/my-stuff',
      'My Stuff',
      undefined,
      { profile_id: this.myProfileId },
    );
  }

  setIndex(index: number): void {
    this.activeRoute = index;
  }

  changeSelectMenu(e: Event): void {
    const menuId = +(e.target as HTMLInputElement).value;

    this.router.navigate([this.menu[menuId].link]);
  }
}
